import store from './store'

let menus = {
  // 员工管理
  user: {
    edit: 2,
    del: 3, // 删除用户
    view: 14, // 查看用户列表
    detail: 17, // 查看用户详情
    entry: 19, // 入职审核
    contract: 20,
    contract_edit: 21,
    contact: 22, // 列表联系方式是否看见
    sub: 23, // 仅查看部门成员
    project: 25, // 仅查看项目成员
    check: 28, // 用户审核
    export: 37 // 导出用户
  },
  apply: { // 29
    view: 31
  },
  documents: {
    view: 51,
    check: 52,
    post: 53
  },
  jobdemand: {
    view: 48,
    export: 49
  },
  office: {
    view: 42, // 浏览出入库记录
    category: 43, // 分类管理
    edit: 44, // 分类管理,
    expressDel: 45, // 快递记录删除
    expressSet: 46 // 更改快递领取状态
  },
  attend: {
    others: 35, // 查看他人考勤
    view_salary: 59, // 查看他人薪资
    view_attend: 35, // 查看他人考勤
    salary: 58, // 上传薪资表
    template_salary: 60, // 薪资模版
    post: 36, // 上传考勤表
    export_salary: 75 // 导出薪资
  },
  // 费用报备
  cost: {
    edit: 5,
    all: 6,
    sub: 24, // 仅查看部门报备
    project: 26// 仅查看项目组报备
  },
  report: {
    count: 56,
    project: 57
  },
  // 权限管理
  group: {
    edit: 8,
    del: 9
  },
  analysis: {
    all: 64,
    view: 62,
    edit: 61,
    del: 63,
    import: 65
  },
  contract: {
    count: 69,
    view_order: 70,
    edit: 71,
    project_edit: 72,
    order_edit: 73,
    confirm_edit: 74
  },
  // 菜单管理
  menu: {
    edit: 11,
    del: 12
  },
  // 组织架构
  structure: {
    edit: 15,
    del: 16,
    view: 18
  },
  wechat: {
    view: 27
  },
  // 是否可以操作
  isPower (menu, button) {
    let id = menus[menu][button]
    let nodes = []
    if (store.state.userInfo.nodes[0] !== undefined) nodes = store.state.userInfo.nodes[0]
    if (store.state.userInfo.status !== 2 && nodes !== 'all') return false
    return nodes === 'all' ? true : store.state.userInfo.nodes.indexOf(String(id)) >= 0
  }
}

export default menus
